// extracted by mini-css-extract-plugin
export default {"main":"DSIFormStudio_main__YZ8EX","tabs":"DSIFormStudio_tabs__slig0","tab":"DSIFormStudio_tab__Mw75x font-sm-regular"};